import { Inject, Injectable } from "@angular/core";
import { CanActivate } from "@angular/router";
import { DeloitteAiEnvironment, DELOITTEAI_ENVIRONMENT } from "@shared/environment";
import { Observable } from "rxjs";

@Injectable({
    providedIn: "root"
})
export class DeployGuard implements CanActivate {

    public constructor(
        @Inject(DELOITTEAI_ENVIRONMENT) private environment: DeloitteAiEnvironment
    ) { }

    canActivate(): Observable<boolean> | Promise<boolean> | boolean {
        return this.environment.context === "store";
    }
}
